export const GET = "userAccounts/GET";
export const LOAD = "userAccounts/LOAD";
export const SELECT = "userAccounts/SELECT";
export const SETSTATUS = "userAccounts/SETSTATUS";
export const CHANGE = "userAccounts/CHANGE";
